import { getSystemState } from "@/features/system-states/system-state";
import { SystemStatePage } from "@/features/system-states/system-state-page";
import SysStale from "@/features/system-states/sys-stale";

export default function StalePage() {
  return (
    <SystemStatePage meta={getSystemState("SYS-03")}>
      <SysStale />
    </SystemStatePage>
  );
}
